import { forwardRef, type HTMLAttributes } from 'react'

import { cn } from '../utils/cn'

interface GlassPanelProps extends HTMLAttributes<HTMLDivElement> {
  /** Rayon de bordure Tailwind */
  rounded?: string
  /** Intensité du blur */
  blur?: 'sm' | 'md' | 'lg'
}

const blurMap = {
  sm: 'backdrop-blur-sm',
  md: 'backdrop-blur-[18px]',
  lg: 'backdrop-blur-[20px]',
} as const

export const GlassPanel = forwardRef<HTMLDivElement, GlassPanelProps>(function GlassPanel(
  { className, rounded = 'rounded-[28px]', blur = 'md', children, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'bg-white/70 dark:bg-slate-900/70',
        blurMap[blur],
        'border border-slate-200/25 dark:border-slate-700/20',
        'shadow-[0_24px_70px_-34px_rgba(37,99,235,0.22)] dark:shadow-[0_30px_90px_-42px_rgba(76,29,149,0.58)]',
        rounded,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})
